/* Keeps the "Earn N Z Points" line under the price in step with the variant.

   The line is server-rendered by snippets/pdp-points-note.liquid for the variant
   the page loads with. That is the wrong variant most of the time — shoppers
   change model, colour and size before buying — so a static number would go
   stale exactly the way the ABOUT band photo did.

   The rate lives on the element as data-rate rather than being duplicated here,
   so Liquid stays the single source and this file never needs editing when the
   client changes the earn rate in the theme settings.

   Public API:  SCPoints.update(cents)   cents = variant price in minor units */
(function () {
  'use strict';

  function group(n) {
    /* Indian digit grouping: 5,600 but 1,25,000. A plain thousands separator
       reads as foreign on a rupee figure. */
    var s = String(n);
    if (s.length <= 3) return s;
    var last3 = s.slice(-3);
    var rest = s.slice(0, -3);
    return rest.replace(/\B(?=(\d\d)+(?!\d))/g, ',') + ',' + last3;
  }

  function update(cents) {
    var el = document.getElementById('sc-pdp-pts');
    if (!el || cents == null || isNaN(cents)) return;

    var rate = parseFloat(el.getAttribute('data-rate')) || 0;
    if (rate <= 0) return;

    var points = Math.floor((cents / 100) * rate);
    if (points <= 0) { el.hidden = true; return; }
    el.hidden = false;

    var text = el.querySelector('span:last-child');
    if (!text) return;

    text.innerHTML = 'Earn <b>' + group(points) + '</b> Z Points';
  }

  /* hide() is for a price the page cannot pin to one variant - the bat PDP's
     "from Rs.X" state. Showing the cheapest variant's points there would quote a
     number for a bat the shopper has not chosen. */
  function hide() {
    var el = document.getElementById('sc-pdp-pts');
    if (el) el.hidden = true;
  }

  window.SCPoints = { update: update, hide: hide };
}());
